export default "__VITE_ASSET__0ejd88J2__"